export const projects = [
    {
      "ProjectUID": "1c019995-1e74-eb11-8af0-005056921d78",
      "ProjectName": "مشروع تقديم خدمات استشارية وفنية في مجال البنية المؤسسية",
      "Department": "إدارة تقنية المعلومات",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "Khalid Abdulaziz Alothman",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 17499995,
      "ApprovedBudget": 17499995,
      "ContractValue": 17499995,
      "RevisedContractValue": 17499995,
      "PaidAmount": "10063211.80",
      "RemainingAmount": 7436783.49,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "جامعة المجمعة ",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2023-04-09T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": " ",
      "ProjectOwner1": "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
      "ProjectOfficerContact": " ",
      "sector_efada": "تحت التنفيذ",
      "pmo_efada": "تحت التنفيذ",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": null
    },
    {
      "ProjectUID": "dd23ed0a-1f74-eb11-8af0-005056921d78",
      "ProjectName": "إتفاقية استثمار في الوكالة",
      "Department": "إدارة الشراكات والمسئولية الإجتماعية",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "منيره مساعد الجبير Monirah M. Aljobair",
      "ProjectDescription": "منتج تمويل الفواتير بالشراكة مع بنك الخليج و منصة بيهايف والتي تستهدف تمويل الفواتير للمنشآت الناشئة والصغيرة",
      "ProjectStartDate": "2019-12-11T00:00:00",
      "ProjectFinishDate": "2021-05-28T17:00:00",
      "BIProjectStartDate": "2019-12-11T08:00:00",
      "BIProjectFinishDate": "2021-05-28T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "الخزينة",
      "EstimatedBudget": 90000000,
      "ApprovedBudget": 90000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
      "تاريخ نهاية المشروع المتوقع": "2021-05-28T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "رفع الانتاجية الاقتصادية",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "الدانة خليفه العجاجي Aldanah K Alajaji",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "ea4f48ae-2274-eb11-8af0-005056921d78",
      "ProjectName": "تطوير منظومة الرقمنة المالية والادارية",
      "Department": "إدارة الفروع والقنوات",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
      "ProjectDescription": "تفعيل مخرجات مشروع الدعم الاستراتيجي للفروع",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 5000000,
      "ApprovedBudget": 5000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-07-13T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Ibrahim A. Alabdusallam",
      "ProjectOwner1": "علي هادي علي مسملي Ali H. Msmali",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "64d66bf0-2a74-eb11-8af0-005056921d78",
      "ProjectName": "مشروع تشغيل وصيانة الفرع الرئيسي",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "بدر سليمان عبدالرحمن العكيل BADR S. ALAKEEL",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2022-02-05T17:00:00",
      "BIProjectStartDate": "2020-02-05T08:00:00",
      "BIProjectFinishDate": "2022-02-05T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 41,
      "BudgetItemNo": "25423",
      "BudgetItemName": "بيت المحترف",
      "EstimatedBudget": 72000000,
      "ApprovedBudget": 69231750,
      "ContractValue": 69231750,
      "RevisedContractValue": 76045500,
      "PaidAmount": "46955050.00",
      "RemainingAmount": 29090450,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة الخليج للتدريب والتعليم",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
      "تاريخ نهاية المشروع المتوقع": "2022-05-20T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "رفع الانتاجية الاقتصادية",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "ناصر رخيص العنزي Nasser R Alanzi",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "تم اضافة طلب تغيير بتمديد مدة المشروع بمقدار 3 شهور و 15 يوم وزيادة تكلفة المشروع بنسبة 9.9 %",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "f7ba5736-2c74-eb11-8af0-005056921d78",
      "ProjectName": "نظام إدارة المراجعة الداخلية",
      "Department": "إدارة الفروع والقنوات",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "خالد عبدالله محمد علي Khaled A. Ali",
      "ProjectDescription": "إيجاد نموذج للفرع يعتمد على التفاعل الرقمي مع العملاء والتواصل الغير مباشر لتقديم الخدمات والمنتجات",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 3000000,
      "ApprovedBudget": 3000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "شبكة الفروع والمباني والتوريد",
      "AwardedCompany": "",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-02-28T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Ibrahim A. Alabdusallam",
      "ProjectOwner1": "علي هادي علي مسملي Ali H. Msmali",
      "ProjectOfficerContact": "وليد سليمان النزهه Waleed S. Alnozha",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "شبكة الفروع والمباني و التوريد",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "1230f0c3-2d74-eb11-8af0-005056921d78",
      "ProjectName": "تقديم استشارات و دراسات هندسية",
      "Department": "إدارة المراجعة التشغيلية وتقنية المعلومات",
      "ProjectOwner": "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
      "ProjectManager": "طارق جمعان الزهراني Tariq J Alzahrani",
      "ProjectDescription": "شراء نظام للمراجعة الداخلية",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2023-09-18T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "3112",
      "BudgetItemName": "تقنية المعلومات",
      "EstimatedBudget": 600000,
      "ApprovedBudget": 600000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع المراجعة الداخلية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2023-09-18T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع المراجعة الداخلية",
      "ProgramManager": " ",
      "ProjectOwner1": "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "af6d183f-2f74-eb11-8af0-005056921d78",
      "ProjectName": "مشروع حصر وتقييم الأصول الثابتة",
      "Department": "إدارة تقنية المعلومات",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "Khalid Abdulaziz Alothman",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 2000000,
      "ApprovedBudget": 2000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": null,
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2023-12-31T00:00:00",
      "BudgetCategory": "الرأس مالية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": " ",
      "ProjectOwner1": "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "تم ضم المشروع لنطاق مشروع (تفعيل النظام الاقراضي الجديد لكامل منتجات وخدمات البنك) ",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "7570ed02-3274-eb11-8af0-005056921d78",
      "ProjectName": "مشروع تصميم و تنفيذ المشاركات في المؤتمرات و المعارض",
      "Department": "إدارة تمويل المنشأت",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "احمد علي الزهراني Ahmad A ِAlzahrani",
      "ProjectDescription": "يهدف هذا المشروع إلى التعاقد مع جهة متخصصة ذات خبرة في مجال التحليل المالي ودراسة الائتمان و المخاطر وتقييم الجدارة والاستحقاق ومتابعة جميع الطلبات الإقراض لعملاء المسار الصحي إضافة إلى تمكين ونقل الخبرات اللازمة ورفع كفاءة الموظفين لدى البنك",
      "ProjectStartDate": "2020-11-06T00:00:00",
      "ProjectFinishDate": "2020-11-06T00:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "25421",
      "BudgetItemName": "بناء نظام الكتروني بنكي للتحليل الائتماني والمالي لطلبات التمويل ",
      "EstimatedBudget": 2341463,
      "ApprovedBudget": 2341463,
      "ContractValue": 2341462.73,
      "RevisedContractValue": 0,
      "PaidAmount": "1,812,746.35 ",
      "RemainingAmount": 1186620,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "جامعة المجمعة معهد الدراسات و الخدمات الاستشارية",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-06-21T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "بناء القدرات",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": " ",
      "ProjectOwner1": "احمد علي الزهراني Ahmad A ِAlzahrani",
      "ProjectOfficerContact": "احمد علي الزهراني Ahmad A ِAlzahrani",
      "sector_efada": "المشروع في مرحلة الاغلاق وجاري رفع الفاتورة النهائية للمشروع بالإضافة الي محضر اغلاق المشروع",
      "pmo_efada": "لمراجعة بيانات الصرف المتبقية",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "c495c538-3974-eb11-8af0-005056921d78",
      "ProjectName": "استكمال تنفيذ المرحلة الثالثة من اعمال المحتوى الوثائقي",
      "Department": "إدارة المحاسبة",
      "ProjectOwner": "ماجد محمد الدخيل Maged M. Aldakheel",
      "ProjectManager": "محمد ابراهيم العرفج Mohammed I Alarfaj",
      "ProjectDescription": "دراسة وتحديد طريقة حصر وقياس أصول البنك بحيث يتم اثباتها وفق معايير المحاسبة الدولية للقطاع العام ودليل السياسات والإجراءات المحاسبية والممارسات الرائدة والقيام بعملية الحصر والتقييم اللازمة لإعداد المركز المالي والقوائم المالية الافتتاحية على أساس الاستحقاق وفق معايير المحاسبة الدولية للقطاع العام",
      "ProjectStartDate": "2020-07-09T00:00:00",
      "ProjectFinishDate": "2020-07-09T00:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2301822",
      "BudgetItemName": "الخدمات الاستشارية",
      "EstimatedBudget": 2500000,
      "ApprovedBudget": 1200000,
      "ContractValue": 1225100,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة برايس وترهاوس كوبرز للاستشارات المحدودة",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع المالية",
      "Program": "برنامج التحول الرقمي والمؤسسي",
      "تاريخ نهاية المشروع المتوقع": "2021-06-01T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "تحقيق الاستدامة المالية",
      "PortfoilioName": "قطاع المالية",
      "ProgramManager": " ",
      "ProjectOwner1": "ماجد محمد الدخيل Maged M. Aldakheel",
      "ProjectOfficerContact": " ",
      "sector_efada": "المشروع منتهي وجاري العمل على الانتهاء من متطلبات اجراءات صرف الدفعة الاخيرة",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "ebba6e15-3b74-eb11-8af0-005056921d78",
      "ProjectName": "تطوير مكتب إدارة المشاريع المؤسسي",
      "Department": "إدارة التسويق والعلاقات العامة",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "خالد راشد الثويني Khaled R Althowaini",
      "ProjectDescription": "يهدف هذا المشروع لتطوير الاستراتيجية الاتصالية والتسويقية لبنك التنمية الاجتماعية وبناء منتجات تسويقية وإعلامية تخدم التوجهات الإعلامية والتسويقية لمنتجات وخدمات ومبادرات البنك إضافة إلى العمل على التحرير والنشر الصحفي في وسائل الإعلام.",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2022-08-01T17:00:00",
      "BIProjectStartDate": "2021-08-01T08:00:00",
      "BIProjectFinishDate": "2022-08-01T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "238",
      "BudgetItemName": "نفقات التسويق والمواد الاعلامية",
      "EstimatedBudget": 2600000,
      "ApprovedBudget": 2424200,
      "ContractValue": 2424200,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة فكرة مضيئة ",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
      "تاريخ نهاية المشروع المتوقع": "2022-08-01T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "بناء القدرات",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "بندر سعيد الغامدي Bandar S. Alghamdi",
      "ProjectOfficerContact": "دانيا عثمان المنيع Dania O. Almanea",
      "sector_efada": "",
      "pmo_efada": "إرفاق ميثاق المشروع - جدول الزمني - قائمة المخرجات ",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "390d09ce-3b74-eb11-8af0-005056921d78",
      "ProjectName": "تطوير تطبيق تحليل الاداء على الأجهزة الذكية",
      "Department": "إدارة التسويق والعلاقات العامة",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "محمد علوش محمد الهديب mohammed a. alhedaib",
      "ProjectDescription": "يهدف هذا المشروع لتنفيذ مشاركات البنك في المعارض والمؤتمرات",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-03-01T17:00:00",
      "BIProjectStartDate": "2021-02-28T08:00:00",
      "BIProjectFinishDate": "2021-03-01T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "23071",
      "BudgetItemName": "تنظيم المعارض والندوات ",
      "EstimatedBudget": 2752140,
      "ApprovedBudget": 2752140,
      "ContractValue": 2752140,
      "RevisedContractValue": null,
      "PaidAmount": "2,012,522.00",
      "RemainingAmount": 739618,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "مؤسسة التنفيذ العالي لتنظيم المعارض والمؤتمرات",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
      "تاريخ نهاية المشروع المتوقع": "2021-03-01T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "بناء القدرات",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "بندر سعيد الغامدي Bandar S. Alghamdi",
      "ProjectOfficerContact": "دانيا عثمان المنيع Dania O. Almanea",
      "sector_efada": "",
      "pmo_efada": "إرفاع الجدول الزمني للمشروع ",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": null
    },
    {
      "ProjectUID": "3d988bf2-5074-eb11-8af0-005056921d78",
      "ProjectName": "مشروع تطوير نموذج العمل (تقديم استشارات)",
      "Department": "إدارة الفروع والقنوات",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-04-21T17:00:00",
      "BIProjectStartDate": "2020-10-21T08:00:00",
      "BIProjectFinishDate": "2021-04-21T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "25321",
      "BudgetItemName": "تصميم واطلاق منظومة التمويل عبر الامتياز التجاري واستقطاب العلامات التجارية 2020",
      "EstimatedBudget": 7000000,
      "ApprovedBudget": 7297900,
      "ContractValue": 7297900,
      "RevisedContractValue": 0,
      "PaidAmount": "8027690.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "شركة ايه تي كيرني السعودية المحدودة ",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
      "تاريخ نهاية المشروع المتوقع": "2021-04-21T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "عهود خالد الربيعة Ahood K ALrabiah",
      "ProjectOwner1": "علي هادي علي مسملي Ali H. Msmali",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "ProjectName": "تطوير منصة رقمية",
      "Department": "إدارة الوثائق والمحفوظات",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "محمد سليمان الصقعبي Mohammed S Alsaqabi",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-06-01T08:00:00",
      "ProjectFinishDate": "2024-06-04T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "31152",
      "BudgetItemName": "مستحقات اصول ثابته سابقة",
      "EstimatedBudget": 7619000,
      "ApprovedBudget": 7619000,
      "ContractValue": 7619000,
      "RevisedContractValue": 0,
      "PaidAmount": "784521",
      "RemainingAmount": 6834478,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة القلعة للمستودعات المحدودة (InfoFort)",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2024-06-06T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": null,
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": " ",
      "ProjectOwner1": "يوسف عبدالعزيز صالح الباحوث Yousef A. AlBahooth",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": null
    },
    {
      "ProjectUID": "8fbe459c-6b74-eb11-8af0-005056921d78",
      "ProjectName": "أنظمة الضوابط الأمنية ورقابتها - أداة أمنية لفحص ومراقبة البنية التحتية والخدمات الإلكترونية",
      "Department": "مكتب إدارة المشاريع المؤسسي",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "محمد مسفر محمد الأحمري mohammed m. alahmari",
      "ProjectDescription": "تطوير ادارة الاستراتيجية و المشاريع بالاستناد إلى أفضل التجارب والممارسات العالمية المشتملة على إدارة المشاريع والبرامج وباستخدام الأنظمة المساندة",
      "ProjectStartDate": "2020-01-11T00:00:00",
      "ProjectFinishDate": "2022-05-29T17:00:00",
      "BIProjectStartDate": "2020-01-11T08:00:00",
      "BIProjectFinishDate": "2022-05-27T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "PR20/028",
      "BudgetItemName": "",
      "EstimatedBudget": 8000000,
      "ApprovedBudget": 7500000,
      "ContractValue": 7500000,
      "RevisedContractValue": 0,
      "PaidAmount": "4,000,000.00",
      "RemainingAmount": 3500000,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "جامعة أم القرى",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": "برنامج التحول الرقمي والمؤسسي",
      "تاريخ نهاية المشروع المتوقع": "2022-05-27T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "بناء القدرات",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "عبدالله عبدالعزيز الناصر Abdullah A. Alnasser",
      "ProjectOfficerContact": " ",
      "sector_efada": "تم اطلاق النظام وانتقاله الى مرحلة تشغيل النظام",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": null
    },
    {
      "ProjectUID": "085d106c-6c74-eb11-8af0-005056921d78",
      "ProjectName": "ابتكار وصناعة الأدوات التسويقية لمنتجات الشركة",
      "Department": "إدارة الإدخار",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
      "ProjectDescription": "تحسين التطبيق الحالي وفق متطلبات القطاع - المرحلة الأولى - اتاحة بقية خدمات الادخار",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 5000000,
      "ApprovedBudget": 5000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "التطبيقات",
      "AwardedCompany": "",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "اعتماد محضر فحص العروض",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-02-28T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
      "ProjectOfficerContact": " ",
      "sector_efada": "في مرحلة توقيع العقود كما تم الاجتماع مع الشركة للتخطيط للمشروع",
      "pmo_efada": "",
      "cat_efada": "التطبيقات ",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "c1be9aaf-6d74-eb11-8af0-005056921d78",
      "ProjectName": "تطوير بوابة الكترونية للتدريب وبناء القدرات",
      "Department": "إدارة المحافظ والتطوير",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عزت فيصل العنقري Ezzat F AlAngari",
      "ProjectDescription": "نظام الية العملية لنقل الطلب الائتماني والخدمات الإضافية للقطاع بين الإدارات المعنية",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 18000000,
      "ApprovedBudget": 18000000,
      "ContractValue": 18000000,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متأخر",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-11-15T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": " ",
      "ProjectOwner1": "فهد علي الاشقر Fahad A. Alashgar",
      "ProjectOfficerContact": "عزت فيصل العنقري Ezzat F AlAngari",
      "sector_efada": "",
      "pmo_efada": "لا يوجد تحديث على المشروع",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "a2e17b14-6f74-eb11-8af0-005056921d78",
      "ProjectName": "تطوير منصة رقمية",
      "Department": "تقديم الخدمات الاستشارية لتنفيذ أعمال المراجعة الداخلية على إدارة تقنية المعلومات",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "منيرة فهد الجبير muneera f. aljubeir",
      "ProjectDescription": "تطوير منصة رقمية تعتمد على منهجية التقنيات الحديثة",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-05-28T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2323/rf",
      "BudgetItemName": "",
      "EstimatedBudget": 9000000,
      "ApprovedBudget": 9000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متأخر",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-05-28T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "الدانة خليفه العجاجي Aldanah K Alajaji",
      "ProjectOfficerContact": " ",
      "sector_efada": "ينتظار موافقة سعادة الرئيس التنفيذي",
      "pmo_efada": "سوف يتم الترحيل للسنة لقادمة ",
      "cat_efada": "",
      "YearBudget": "0",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "5c8b21da-6f74-eb11-8af0-005056921d78",
      "ProjectName": "شراء نظام متابعة المعاملات القانونية",
      "Department": "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "يزيد محمد القديري Yazeed M. Alqedairi",
      "ProjectDescription": "أنظمة وأدوات لمراقبة وفحص وقياس تطبيق ضوابط هيئة الأمن السيبراني والتشريعات ذات العلاقة للحد من المخاطر الأمنية المترتبة ، ولتعزيز قدرات الأمن السيبراني في البنك .",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "أنظمة الضوابط الأمنية ورقابتها ",
      "EstimatedBudget": 226963.77,
      "ApprovedBudget": 226963.77,
      "ContractValue": 226963.77,
      "RevisedContractValue": 226963.77,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": null,
      "AwardedCompany": "شركة الحماية المرنة للاتصالات وتقنية المعلومات",
      "ProjectPhase": "البدء",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "اصدار التوصية",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2025-01-16T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": " ",
      "ProjectOwner1": "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "0771a8ce-7374-eb11-8af0-005056921d78",
      "ProjectName": "تقديم الخدمات الاستشارية لتطوير إدارة الميزانية والتخطيط المالي",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عبدالعزيز مطر اللويحق Abdulaziz M Alluwaihiq",
      "ProjectDescription": "إقامة مؤتمريسلط الضوء على ماتقدمه الدولة ممثلة ببنك التنمية الاجتماعية في مجال التمويل الاصغر يتم من خلاله دعوة متخصصين في مجال التمويل الاصغر و عرض التجارب وأهم الدراسات بالإضافة إلى إقامة ورش العمل ودورات تدريبية على هامش الفعالية",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 5000000,
      "ApprovedBudget": 5000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متأخر",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-10-15T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "سعد حمد سعد بن عيد SAAD H. BINEID",
      "ProjectOwner1": " ",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "سيتم ترحيلة للعام 2022",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "b5a39ea6-7474-eb11-8af0-005056921d78",
      "ProjectName": "تطوير نظام تخطيط موارد المؤسسات للانتقال من العمل على الأساس النقدي الى أساس الاستحقاق",
      "Department": "إدارة تمويل العمل الحر",
      "ProjectOwner": "عادل عبدالله سعد الجويان adel a aljoyan",
      "ProjectManager": "سامي سليمان الجربوع Sami S. Aljarboua",
      "ProjectDescription": "الاشتراك في خدمة تم المقدمة من خلال شركة علم",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-08-25T17:00:00",
      "BIProjectStartDate": "2020-08-24T08:00:00",
      "BIProjectFinishDate": "2021-08-25T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "232012",
      "BudgetItemName": "توفير رسائل نصيه",
      "EstimatedBudget": 33090,
      "ApprovedBudget": 33090,
      "ContractValue": 33090,
      "RevisedContractValue": 0,
      "PaidAmount": "0",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة علم",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-09-15T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": " ",
      "ProjectOwner1": "عادل عبدالله سعد الجويان adel a aljoyan",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "83f8ec0e-7674-eb11-8af0-005056921d78",
      "ProjectName": "تطوير نظام مراجعة الأداء والاستراتيجية",
      "Department": "إدارة التسويق والعلاقات العامة",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "منيره حمد بن عبيد Munirah H. Bin obaid",
      "ProjectDescription": "حملات تسويقية و توعوية لمنتجات الاسر المنتجة كجزء من اختصاص البنك كمظلة للاسر المنتجة",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "271",
      "BudgetItemName": "الأسر المنتجة",
      "EstimatedBudget": 8000000,
      "ApprovedBudget": 6116390,
      "ContractValue": 6116390,
      "RevisedContractValue": 6116390,
      "PaidAmount": "3,389,208.00",
      "RemainingAmount": 2727182,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "وكالة مروان لدعاية والإعلان والعلاقات العامة للتسويق",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-12-06T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": "خالد راشد الثويني Khaled R Althowaini",
      "ProjectOwner1": "بندر سعيد الغامدي Bandar S. Alghamdi",
      "ProjectOfficerContact": "دانيا عثمان المنيع Dania O. Almanea",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "2,727,182.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "77d44a8b-7674-eb11-8af0-005056921d78",
      "ProjectName": "تطوير استراتيجية التسويق وتحسين تجربة العميل",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
      "ProjectDescription": "تأسيس 20 منفذ بيع دائم لبيع منتجات الاسر المنتجة وتشغيلها لمدة سنتين بالاضافة إلى تصميم هوية تجارية مسجلة",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 5977815,
      "ApprovedBudget": 5977815,
      "ContractValue": 5977815,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "اروقة الريادة للتجارة",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2024-05-04T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "سعد حمد سعد بن عيد SAAD H. BINEID",
      "ProjectOwner1": "ناصر رخيص العنزي Nasser R Alanzi",
      "ProjectOfficerContact": "عبدالعزيز مطر اللويحق Abdulaziz M Alluwaihiq",
      "sector_efada": "تم استلام الخطة الزمنية ونموذج ميثاق المشروع من قبل الشركة",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "0c6e23b3-7874-eb11-8af0-005056921d78",
      "ProjectName": "تنفيذ الاعمال الهندسية المطلوبة للفروع",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "رشا عبدالعزيز محمد برخيل Rasha A. Albarkheel",
      "ProjectDescription": "تطوير منظومة متكاملة للخدمات غير المالية",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 8000000,
      "ApprovedBudget": 220250,
      "ContractValue": 2202250,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "الأنظمة والتطوير",
      "AwardedCompany": "مؤسسة التناغم التقني",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-05-30T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "سعد حمد سعد بن عيد SAAD H. BINEID",
      "ProjectOwner1": "ناصر رخيص العنزي Nasser R Alanzi",
      "ProjectOfficerContact": "رشا عبدالعزيز محمد برخيل Rasha A. Albarkheel",
      "sector_efada": "تم البدء في مرحلة التخطيط للمشروع",
      "pmo_efada": "",
      "cat_efada": "الأنظمة و التطوير ",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "76f78015-8274-eb11-8af0-005056921d78",
      "ProjectName": "توريد اثاث المنطقة الشرقية",
      "Department": "إدارة المراجعة التشغيلية وتقنية المعلومات",
      "ProjectOwner": "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
      "ProjectManager": "طارق جمعان الزهراني Tariq J Alzahrani",
      "ProjectDescription": "الاستعانة بشركة استشارية متخصصة لتنفيذ أعمال المراجعة على الإدارة العامة لتقنية المعلومات",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-12-16T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 24,
      "BudgetItemNo": "2310",
      "BudgetItemName": "الخدمات الاستشارية",
      "EstimatedBudget": 400000,
      "ApprovedBudget": 400000,
      "ContractValue": 400000,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة بروتيفيتي ممبر فيرم السعودية للاستشارات الادارية",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع المراجعة الداخلية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-12-09T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": null,
      "PortfoilioName": "قطاع المراجعة الداخلية",
      "ProgramManager": " ",
      "ProjectOwner1": "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "62f10be3-8274-eb11-8af0-005056921d78",
      "ProjectName": "تأسيس وتشغيل مكتب البنية المؤسسية لإدارة تقنية المعلومات",
      "Department": "إدارة القضايا",
      "ProjectOwner": "ناصر عبدالعزيز بن فراج الثويني nasser a. althowaini",
      "ProjectManager": "سامي صالح فاضل العمري sami s. alamri",
      "ProjectDescription": "نظام إلكتروني متكامل احترافي خاص بعمل الادارة القانونية من قضايا و استشارات و تحقيق ، بأسلوب تقني حديث على ان تكون تطبيقاته تعمل بفعالية وأداء عالي بالإضافة إلى جاذبية التصميم وسهولة الاستخدام.",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-12-30T17:00:00",
      "BIProjectStartDate": "2021-06-01T08:00:00",
      "BIProjectFinishDate": "2021-12-30T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "3112",
      "BudgetItemName": "تقنية المعلومات",
      "EstimatedBudget": 600000,
      "ApprovedBudget": 600000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "الإدارة القانونية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-12-30T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "الإدارة القانونية",
      "ProgramManager": " ",
      "ProjectOwner1": "ناصر عبدالعزيز بن فراج الثويني nasser a. althowaini",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "6dc18cb3-8374-eb11-8af0-005056921d78",
      "ProjectName": "مشروع معالجة المعلقات المالية",
      "Department": "إدارة التقارير والميزانية",
      "ProjectOwner": "ماجد محمد الدخيل Maged M. Aldakheel",
      "ProjectManager": "احمد حمد عبدالله القدير Ahmad H. AlQedair",
      "ProjectDescription": "\"أتمته التقارير ولوحة مؤشرات الأداء ومراحل تقديرات الموازنة التفاعلية بحيث تشمل :",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2320",
      "BudgetItemName": "مستحقات مصاريف عمومية وادارية",
      "EstimatedBudget": 1250000,
      "ApprovedBudget": 0,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع المالية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-12-31T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع المالية",
      "ProgramManager": " ",
      "ProjectOwner1": "عادل عبدالله الدحيم Adel A. Alduhaim",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "56495302-8474-eb11-8af0-005056921d78",
      "ProjectName": "تقديم خدمات استشارية وتنفيذ المعسكرات التدريبية المتخصصة",
      "Department": "إدارة التقارير والميزانية",
      "ProjectOwner": "ماجد محمد الدخيل Maged M. Aldakheel",
      "ProjectManager": "فهد عائش العتيبي Fahad A. Alotaibi",
      "ProjectDescription": "تطوير نظام تخطيط موارد المؤسسات للانتقال من العمل على الأساس النقدي إلى أساس الاستحقاق تقنياً",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 3000000,
      "ApprovedBudget": 0,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع المالية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-11-14T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع المالية",
      "ProgramManager": " ",
      "ProjectOwner1": "محمد ابراهيم العرفج Mohammed I Alarfaj",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "6d22444e-8574-eb11-8af0-005056921d78",
      "ProjectName": "عمليات الأمن السيبراني وتقييم المخاطر بحسب ضوابط الأمن السيبراني والمعيار العالمي ISO 27001",
      "Department": "إدارة التخطيط الاستراتيجي",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "حازم يوسف اليوسف Hazim Ussef Al-Ussef",
      "ProjectDescription": "تطوير نظام متخصص في متابعة الأداء والاستراتيجية",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-06-02T17:00:00",
      "BIProjectStartDate": "2021-06-01T08:00:00",
      "BIProjectFinishDate": "2021-06-02T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "3112",
      "BudgetItemName": "تقنية المعلومات",
      "EstimatedBudget": 2000000,
      "ApprovedBudget": null,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متأخر",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-06-02T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": " ",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "622b1d20-8674-eb11-8af0-005056921d78",
      "ProjectName": "مشروع تأسيس و تشغيل منصة ذكاء الأعمال",
      "Department": "إدارة الفروع والقنوات",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "خالد عبدالله محمد علي Khaled A. Ali",
      "ProjectDescription": "تشغيل مساحات العمل المشترك لعدد 2 فروع - المرحلة الثانية",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "3111",
      "BudgetItemName": "",
      "EstimatedBudget": 4580000,
      "ApprovedBudget": 4580000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "شبكة الفروع والمباني والتوريد",
      "AwardedCompany": "",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-11-20T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Ibrahim A. Alabdusallam",
      "ProjectOwner1": "علي هادي علي مسملي Ali H. Msmali",
      "ProjectOfficerContact": " ",
      "sector_efada": "سيتم استكمال متطلبات الطرح بعد استلام عقود المباني للمرحلة الثانية وطرح مشروع تأهيلها ",
      "pmo_efada": "",
      "cat_efada": "شبكة الفروع والمباني و التوريد",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "bb43ec17-8774-eb11-8af0-005056921d78",
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال المنظومة مع الجهات الشريكة",
      "Department": "إدارة التسويق والعلاقات العامة",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "خالد راشد الثويني Khaled R Althowaini",
      "ProjectDescription": "حملات رقمية وترويجية لخدمات البنك",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-05-27T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 5000000,
      "ApprovedBudget": 3213030,
      "ContractValue": 2923000,
      "RevisedContractValue": 3213030,
      "PaidAmount": "2923000.00",
      "RemainingAmount": 290300,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة فكرة مضيئة للدعاية والاعلان",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-05-27T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "بندر سعيد الغامدي Bandar S. Alghamdi",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "تم رفع طلب إضافة على العقد 10%",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": null
    },
    {
      "ProjectUID": "4df58b8a-8874-eb11-8af0-005056921d78",
      "ProjectName": "تقديم خدمات استشارية في تطوير وتقييم نماذج الأعمال والعمليات والتحليل وبناء الأسس اللازم لتكاملها مع الأنظمة التقنية",
      "Department": "إدارة التسويق والعلاقات العامة",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "خالد راشد الثويني Khaled R Althowaini",
      "ProjectDescription": "بناء منتجات إبداعية وإعلامية للبنك",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-05-31T17:00:00",
      "BIProjectStartDate": "2021-05-30T08:00:00",
      "BIProjectFinishDate": "2021-05-31T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2311",
      "BudgetItemName": "",
      "EstimatedBudget": 9000000,
      "ApprovedBudget": 9000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متأخر",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-05-31T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "بندر سعيد الغامدي Bandar S. Alghamdi",
      "ProjectOfficerContact": " ",
      "sector_efada": "مشروع ملغي بناء على توجيه سعادة نائب قطاع الاستراتيجية والابتكار ",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "07e4f787-8974-eb11-8af0-005056921d78",
      "ProjectName": "تقديم خدمات استشارية وتطوير الاعمال",
      "Department": "إدارة الفروع والقنوات",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "خالد عبدالله محمد علي Khaled A. Ali",
      "ProjectDescription": "غير موجودة بياناتها في قائمة التمويل الاجتماعي",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-01-10T17:00:00",
      "BIProjectStartDate": "2020-11-15T08:00:00",
      "BIProjectFinishDate": "2021-01-10T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "s",
      "EstimatedBudget": 3933890,
      "ApprovedBudget": 3933890,
      "ContractValue": 3933890,
      "RevisedContractValue": 4326654,
      "PaidAmount": "3211378.16",
      "RemainingAmount": 1115276.49,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "شبكة الفروع والمباني والتوريد",
      "AwardedCompany": "شركة الراجحي للبناء والتعمير",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-01-10T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Ibrahim A. Alabdusallam",
      "ProjectOwner1": "علي هادي علي مسملي Ali H. Msmali",
      "ProjectOfficerContact": "غدير الحارثي Gadeer Alharthi",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "93c4effd-8974-eb11-8af0-005056921d78",
      "ProjectName": "تقديم خدمات استشارية في تطوير أدلة ونماذج الزيارة الميدانية لضمان التزام الجهات الشريكة",
      "Department": "إدارة الفروع والقنوات",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "خالد عبدالله محمد علي Khaled A. Ali",
      "ProjectDescription": "تغيير عدد 21 فرع و تضمين عدد من الفروع لمبادرة جادة 30 وهي كالتالي ( حائل - جدة - الجوف - جازان - ينبع - المدينة المنورة - نجران - عرعر -القنفذه- حفر الباطن - بيشه - القريات - النماص - مكة المكرمة - الطائف - المجمعة - الخرج - الرس - الباحة - الدوادمي - وادي الدواسر )",
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "محذوف من قائمة الخدمات الأخيرة",
      "EstimatedBudget": 3500000,
      "ApprovedBudget": 3500000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "شبكة الفروع والمباني والتوريد",
      "AwardedCompany": "",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-02-28T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Ibrahim A. Alabdusallam",
      "ProjectOwner1": "علي هادي علي مسملي Ali H. Msmali",
      "ProjectOfficerContact": "وليد سليمان النزهه Waleed S. Alnozha",
      "sector_efada": "تم اعتماد كافة العينات على ان يتم التوريد عند الانتهاء من أعمال التأهيل لكل موقع",
      "pmo_efada": "",
      "cat_efada": "شبكة الفروع والمباني و التوريد",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "ec7ee3e4-8d74-eb11-8af0-005056921d78",
      "ProjectName": "نظام إدارة تخطيط الموارد المؤسسي (ERP)",
      "Department": "إدارة تقنية المعلومات",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "كامل صطام جراد Kamel S Jarad",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-21T08:00:00",
      "ProjectFinishDate": "2021-02-21T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2413115",
      "BudgetItemName": "",
      "EstimatedBudget": 4800000,
      "ApprovedBudget": 4800000,
      "ContractValue": 4800000,
      "RevisedContractValue": 5999181,
      "PaidAmount": "299960.00",
      "RemainingAmount": 5699221,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة ديفوتيم السعودية المحدودة",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": "برنامج التحول الرقمي والمؤسسي",
      "تاريخ نهاية المشروع المتوقع": "2024-12-04T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": "نوره محمد أبونيان Noura M. Abunayyan",
      "ProjectOwner1": "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
      "ProjectOfficerContact": " ",
      "sector_efada": "تم توقيع العقد و جاري العمل مع المقاول لإعداد ميثاق المشروع و من ثم خطة المشروع ",
      "pmo_efada": "تم توقيع العقد و حالياً بانتظار ميثاق المشروع و خطة المشروع ",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "f704c371-b574-eb11-8af0-005056921d78",
      "ProjectName": "مشروع تطوير انظمة متعددة للقطاع (المرحلة الاولى)",
      "Department": "إدارة المحاسبة",
      "ProjectOwner": "ماجد محمد الدخيل Maged M. Aldakheel",
      "ProjectManager": "حماد عبدالله صالح المحيسن Hammad A. AlMuhaysin",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2301826",
      "BudgetItemName": "خدمات استشارية لمعالجة المعلقات المالية",
      "EstimatedBudget": 2500000,
      "ApprovedBudget": 0,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع المالية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-10-04T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع المالية",
      "ProgramManager": " ",
      "ProjectOwner1": "محمد ابراهيم العرفج Mohammed I Alarfaj",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "b502d22f-bf74-eb11-8af0-005056921d78",
      "ProjectName": "مشروع خدمات اتصالية رقمية",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عبدالله سعيد عوض السبيعي abdullah s. alsubaie",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "273",
      "BudgetItemName": "البيت المحترف",
      "EstimatedBudget": 4500000,
      "ApprovedBudget": 1533882,
      "ContractValue": 1533882,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "هيود",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-09-29T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "سعد حمد سعد بن عيد SAAD H. BINEID",
      "ProjectOwner1": "ناصر رخيص العنزي Nasser R Alanzi",
      "ProjectOfficerContact": "عبدالله سعيد عوض السبيعي abdullah s. alsubaie",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "6d984262-c274-eb11-8af0-005056921d78",
      "ProjectName": "إستبدال نظام الاتصالات الإدارية",
      "Department": "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "يزيد محمد القديري Yazeed M. Alqedairi",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 2297700,
      "ApprovedBudget": 2297700,
      "ContractValue": 2297700,
      "RevisedContractValue": 2297700,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "الشركة السعودية للحاسبات الالكترونية المحدودة",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2025-01-17T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": " ",
      "ProjectOwner1": "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
      "ProjectOfficerContact": " ",
      "sector_efada": "بانتظار تجهيز البنك للبنية التحتية المطلوبة من المقاول لبدء اعمال المشروع",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "d4877129-c374-eb11-8af0-005056921d78",
      "ProjectName": "تطوير وتشغيل مركز تجاري ترفيهي ",
      "Department": "إدارة تقنية المعلومات",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "عبدالعزيز حازم المزروع Abdulaziz H Al Mazrou",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 4000000,
      "ApprovedBudget": 4000000,
      "ContractValue": 4000000,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "التقييم الفني",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-10-30T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": "نوره محمد أبونيان Noura M. Abunayyan",
      "ProjectOwner1": "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
      "ProjectOfficerContact": " ",
      "sector_efada": "بانتظار الضمان النهائي للمشروع و جاري عداد مسودة العقد",
      "pmo_efada": "في مرحلة فحص العروض ",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "ProjectName": "تصميم وبناء عدد ٥٠٠ وحدة سكنية بالقطاع الغربي",
      "Department": "إدارة تمويل الأسر المنتجة",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "فهد علي عبدالله العواد Fahad A. Alawad",
      "ProjectDescription": "رفع الحوكمة والقدرات للجهات الشريكة في تقديم الإقراض للأسر المنتجة",
      "ProjectStartDate": "2020-12-24T08:00:00",
      "ProjectFinishDate": "2021-06-28T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "25125",
      "BudgetItemName": "الاسر المنتجة",
      "EstimatedBudget": 2300000,
      "ApprovedBudget": 3000000,
      "ContractValue": 3000000,
      "RevisedContractValue": 0,
      "PaidAmount": "2791979.4",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": null,
      "AwardedCompany": "شركة برايس واتر هاوس",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-06-24T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": null,
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "عهود خالد الربيعة Ahood K ALrabiah",
      "ProjectOwner1": " ",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "87fcd659-c974-eb11-8af0-005056921d78",
      "ProjectName": "رفع مؤشر قياس التحول الإلكتروني (يسر)",
      "Department": "إدارة المحافظ والتطوير",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-10-27T17:00:00",
      "BIProjectStartDate": "2020-02-02T08:00:00",
      "BIProjectFinishDate": "2021-10-27T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 68,
      "BudgetItemNo": "25322",
      "BudgetItemName": "الامتياز التجاري",
      "EstimatedBudget": 914000,
      "ApprovedBudget": 914000,
      "ContractValue": 914000,
      "RevisedContractValue": 0,
      "PaidAmount": "914000.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": null,
      "AwardedCompany": "جامعة أم القرى",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
      "تاريخ نهاية المشروع المتوقع": "2021-10-27T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": null,
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "عهود خالد الربيعة Ahood K ALrabiah",
      "ProjectOwner1": "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "0f9f9ad6-c974-eb11-8af0-005056921d78",
      "ProjectName": "تطوير قسم اختبار التطبيقات",
      "Department": "مكتب إدارة مشاريع الأعمال",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عهود خالد الربيعة Ahood K ALrabiah",
      "ProjectDescription": null,
      "ProjectStartDate": "2020-10-04T00:00:00",
      "ProjectFinishDate": "2021-04-23T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 38,
      "BudgetItemNo": "2301814",
      "BudgetItemName": "الخدمات الاستشارية",
      "EstimatedBudget": 1500000,
      "ApprovedBudget": 1496243,
      "ContractValue": 1496243.7,
      "RevisedContractValue": 0,
      "PaidAmount": "1242538",
      "RemainingAmount": 253705,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": null,
      "AwardedCompany": "جامعة المجمعة",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
      "تاريخ نهاية المشروع المتوقع": "2021-04-22T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": null,
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "عبدالعزيز عبدالله الغريري Abdulaziz A. Algheriri",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "4b70164d-ca74-eb11-8af0-005056921d78",
      "ProjectName": "رفع الالتزام بتطبيق معايير وممارسات تقنية المعلومات",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "تركي عبدالمحسن المنيف Turki A Almunaif",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2301817",
      "BudgetItemName": "زيادة نطاق لمشروع تقديم الخدمات الاستشارية لتقييم وتحليل جميع عمليات الإقراض والتحصيل بالبنك",
      "EstimatedBudget": 2714250,
      "ApprovedBudget": 246750,
      "ContractValue": 246750,
      "RevisedContractValue": 0,
      "PaidAmount": "246750.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": null,
      "AwardedCompany": "شركة كي بي إم جي الفوزان وشركاه محاسبون ومراجعون قانونيون",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2020-04-21T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": " ",
      "ProjectOwner1": " ",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "b1d0ffcc-d174-eb11-8af0-005056921d78",
      "ProjectName": "تصميم وانشاء فرع الرياض",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "غاده عبدالله الحربي Gadah A Alharbi",
      "ProjectDescription": "إقامة ورش تنمية المهارات السلوكية لرواد الأعمال",
      "ProjectStartDate": "2020-02-03T00:00:00",
      "ProjectFinishDate": "2024-07-01T17:00:00",
      "BIProjectStartDate": "2020-11-17T08:00:00",
      "BIProjectFinishDate": "2024-07-01T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "25424",
      "BudgetItemName": "بيت المحترف",
      "EstimatedBudget": 9530137.5,
      "ApprovedBudget": 9530137.5,
      "ContractValue": 9530137.5,
      "RevisedContractValue": 0,
      "PaidAmount": "3211378.16",
      "RemainingAmount": 6318759.34,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "جمعية ريادة الاعمال",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
      "تاريخ نهاية المشروع المتوقع": "2024-07-01T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "رفع الانتاجية الاقتصادية",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "سعد حمد سعد بن عيد SAAD H. BINEID",
      "ProjectOwner1": "ناصر رخيص العنزي Nasser R Alanzi",
      "ProjectOfficerContact": "غاده عبدالله الحربي Gadah A Alharbi",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "4d9531e1-f074-eb11-8af1-005056921d78",
      "ProjectName": "الربط بين الأنظمة المالية المستخدمة",
      "Department": "إدارة تمويل الأسر المنتجة",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "خالد فايز الدوسري Khalid F Aldosari",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 6000000,
      "ApprovedBudget": 3499567.05,
      "ContractValue": 3499567.05,
      "RevisedContractValue": 0,
      "PaidAmount": "2164856.40",
      "RemainingAmount": 1334711,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة وافي العالمية",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2020-04-21T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "ac1650d6-f174-eb11-8af1-005056921d78",
      "ProjectName": "تطوير منظومة مكتب إدارة المشاريع في قطاع الاعمال",
      "Department": "إدارة الشراكات والمسئولية الإجتماعية",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "منيره مساعد الجبير Monirah M. Aljobair",
      "ProjectDescription": "مشروع عطاءات يهدف الى دعم رواد الأعمال في قطاع المنشآت الصغيرة والمتوسطة المتخصصة في مجالات التوريد لتمكينهم من الفوز وتنفيذ المنافسات الحكومية المقدمة عبر منصة اعتماد",
      "ProjectStartDate": "2018-01-08T00:00:00",
      "ProjectFinishDate": "2021-08-31T17:00:00",
      "BIProjectStartDate": "2020-07-14T08:00:00",
      "BIProjectFinishDate": "2021-08-31T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 0,
      "ApprovedBudget": 0,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "شركة ثقة",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
      "تاريخ نهاية المشروع المتوقع": "2021-08-31T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "رفع الانتاجية الاقتصادية",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": " ",
      "ProjectOwner1": "الدانة خليفه العجاجي Aldanah K Alajaji",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "6fb4fc1e-f574-eb11-8af1-005056921d78",
      "ProjectName": "تجهيز وتأثيث مباني الفروع",
      "Department": "إدارة الإدخار",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "خواطر احمد عبدالله الخويطر Khawater A Alkhowaiter",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2020-12-10T17:00:00",
      "BIProjectStartDate": "2019-12-10T08:00:00",
      "BIProjectFinishDate": "2020-12-10T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "232014",
      "BudgetItemName": "تصميم برامج التوفير والادخار",
      "EstimatedBudget": 588215,
      "ApprovedBudget": 588215,
      "ContractValue": 588215,
      "RevisedContractValue": 0,
      "PaidAmount": "411764.50",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (3)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "جامعة المجمعة",
      "ProjectPhase": "الإغلاق",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
      "تاريخ نهاية المشروع المتوقع": "2020-12-10T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "يوجد متبقي للصرف للتوضيح",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "807c599e-f574-eb11-8af1-005056921d78",
      "ProjectName": "تطوير قناة الواتساب للأعمال",
      "Department": "إدارة الفروع والقنوات",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "خالد عبدالله محمد علي Khaled A. Ali",
      "ProjectDescription": "توفير بيئة عمل جاذبة لرواد الاعمال وأصحاب المنشآت لخلق فرص تمويلية من قبل البنك",
      "ProjectStartDate": "2020-02-02T00:00:00",
      "ProjectFinishDate": "2023-10-21T17:00:00",
      "BIProjectStartDate": "2020-04-22T08:00:00",
      "BIProjectFinishDate": "2023-10-21T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2411211",
      "BudgetItemName": "الترميمات والتحسينات",
      "EstimatedBudget": 22999200,
      "ApprovedBudget": 22999200,
      "ContractValue": 22999200,
      "RevisedContractValue": 22999200,
      "PaidAmount": "12380910",
      "RemainingAmount": 10618290,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "أماكن الاعمال المحدودة",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
      "تاريخ نهاية المشروع المتوقع": "2023-10-21T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "رفع الانتاجية الاقتصادية",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Ibrahim A. Alabdusallam",
      "ProjectOwner1": "علي هادي علي مسملي Ali H. Msmali",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "9fe464d1-fc74-eb11-8af1-005056921d78",
      "ProjectName": "متابعة وتقييم أداء عمليات محافظ الجهات الشريكة",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عبدالعزيز مطر اللويحق Abdulaziz M Alluwaihiq",
      "ProjectDescription": "تقديم حزمة من الخدمات من خلال بناء وتشغيل أنظمة المدفوعات الإلكترونية للمساعدة على تنظيم حسابات وفوترة عملاء البنك و تمكينهم من حلول الدفع الرقمية المتقدمة و قياس الأثر الإقراضي",
      "ProjectStartDate": "2020-03-05T00:00:00",
      "ProjectFinishDate": "2020-03-05T00:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "25121",
      "BudgetItemName": "الاسر المنتجة",
      "EstimatedBudget": 5000000,
      "ApprovedBudget": 5000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": null,
      "AwardedCompany": "جيديا",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "متأخر",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
      "تاريخ نهاية المشروع المتوقع": "2022-02-21T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "تعزيز الاستقلال المالي",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "ناصر رخيص العنزي Nasser R Alanzi",
      "ProjectOfficerContact": " ",
      "sector_efada": "التوصية بتسليم محضر الغاء المشروع",
      "pmo_efada": "للتأكد على الحصول على محضر الغاء المشروع",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "90771740-fd74-eb11-8af1-005056921d78",
      "ProjectName": "تحديث الدليل الإجرائي",
      "Department": "إدارة تمويل الأسر المنتجة",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "اسامه محمد عبدالله الجار الله Osama M. Aljarallh",
      "ProjectDescription": null,
      "ProjectStartDate": "2020-09-22T00:00:00",
      "ProjectFinishDate": "2020-09-22T00:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "25126",
      "BudgetItemName": "الاسر المنتجة",
      "EstimatedBudget": 2500000,
      "ApprovedBudget": 2500000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متأخر",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-06-19T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "لا يوجد تحديث على المشروع",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "87b3ddbd-fd74-eb11-8af1-005056921d78",
      "ProjectName": "الخدمات الاستشارية و الفنية لإكمال المقر الرئيسي",
      "Department": "إدارة الإدخار",
      "ProjectOwner": "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
      "ProjectManager": "خواطر احمد عبدالله الخويطر Khawater A Alkhowaiter",
      "ProjectDescription": "إيجاد برنامج يعزز الوعي المالي وثقافة الادخار لدى الأطفال ويتيح لهم التعامل بشكل حقيقي مع حسابهم الادخاري من خلال استخدام أفضل الممارسات التقنية وبرقابة من الآباء وباستهداف شريحة الأطفال من عمر 6- 18 سنة",
      "ProjectStartDate": "2020-06-28T08:00:00",
      "ProjectFinishDate": "2021-12-17T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "232021",
      "BudgetItemName": "تصميم برامج التوفير والادخار",
      "EstimatedBudget": 1750000,
      "ApprovedBudget": 17100000,
      "ContractValue": 1795500,
      "RevisedContractValue": 1974900,
      "PaidAmount": "890000.00",
      "RemainingAmount": 1084900,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "مكتب وسم الاستدامة للخدمات التجارية",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
      "تاريخ نهاية المشروع المتوقع": "2022-02-15T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "تمكين الحماية الاجتماعية",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "تم اضافة طلب تغيير تمديد في المدة والتكاليف والكميات بنسبة 10 % من الميزانية المعتمدة",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "c3aaf378-ff74-eb11-8af1-005056921d78",
      "ProjectName": "تقديم الاستشارات والخدمات لدعم العمليات التشغيلية للمنشآت",
      "Department": "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "طارق سليمان المحمود Tarek S Almahmoud",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "2310",
      "BudgetItemName": "الخدمات الاستشارية",
      "EstimatedBudget": 150000,
      "ApprovedBudget": 0,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متوقع التأخير/ملاحظة مهمة",
      "ContractStatus": "الداخلي",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-11-30T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": " ",
      "ProjectOwner1": "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
      "ProjectOfficerContact": " ",
      "sector_efada": "تم رفع التوصية الفنية لسعادة الرئيس التنفيذي لالغاء المشروع ",
      "pmo_efada": "",
      "cat_efada": "شبكة الفروع والمباني و التوريد",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "ProjectName": "تأهيل عدد 6 مواقع  المرحلة الثانية في كل من (المدينة المنورة - جده - مكة المكرمة - جازان - الجوف - حائل)",
      "Department": "إدارة المحافظ والتطوير",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عزت فيصل العنقري Ezzat F AlAngari",
      "ProjectDescription": "يهدف هذا البرنامج إلى تحقيق أهداف القطاع الاستراتيجية وذلك من خلال انشاء انظمة تشغيلية متكاملة لتصميم وتطوير وتنفيذ عمليات وإجراءات إدارة التمويل للمنشآت الصغيرة والناشئة ويكون الحل المقدم قابل لأتمتة مستقبلا",
      "ProjectStartDate": "2020-04-08T00:00:00",
      "ProjectFinishDate": "2021-10-13T09:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 65,
      "ActualCompletePercent": 65,
      "BudgetItemNo": "25322",
      "BudgetItemName": "دراسات استشارية لتنمية قطاع المنشآت الصغيرة والناشئة والتمويل الأصغر2020",
      "EstimatedBudget": 7212269.8,
      "ApprovedBudget": 7212269.8,
      "ContractValue": 7021269.8,
      "RevisedContractValue": 0,
      "PaidAmount": "5,440,318.75 ",
      "RemainingAmount": 4988244.34,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "شركة ديلويت اند توش الشرق الاوسط المحدودة",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
      "تاريخ نهاية المشروع المتوقع": "2021-10-29T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "إستراتيجي",
      "PlannedResourceHours": 6426,
      "ActualResourceHours": 4194,
      "StrategicObjectives": "رفع الانتاجية الاقتصادية",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": " ",
      "ProjectOwner1": "فهد علي الاشقر Fahad A. Alashgar",
      "ProjectOfficerContact": "عزت فيصل العنقري Ezzat F AlAngari",
      "sector_efada": "يوجد تأخير في تسليم احد مخرجات المشروع مع الإحاطة بانه تاريخ المشروع منتهي وجاري العمل امر التغير رفع مدة المشروع الي 3 اشهر دون تكاليف مالية ",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "19bbe9df-0375-eb11-8af1-005056921d78",
      "ProjectName": "إعادة بناء تطبيق الجوال",
      "Department": "إدارة التسويق والعلاقات العامة",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "عبدالعزيز عبدالرحمن عبدالعزيز العتيق abdulaziz a. alateeg",
      "ProjectDescription": "بناء الأجنحة وتجهيزات المشاركة في الفعاليات والمعارض المؤقتة",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2022-09-01T17:00:00",
      "BIProjectStartDate": "2021-09-01T08:00:00",
      "BIProjectFinishDate": "2022-09-01T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "237",
      "BudgetItemName": "تنظيم المعارض والندوات والمؤتمرات",
      "EstimatedBudget": 6900000,
      "ApprovedBudget": 6866675,
      "ContractValue": 6866675,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 6866675,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-09-01T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": "محمد علوش محمد الهديب mohammed a. alhedaib",
      "ProjectOwner1": "بندر سعيد الغامدي Bandar S. Alghamdi",
      "ProjectOfficerContact": "اشواق عمر إبراهيم السليم Ashwag O. Al-Saliem",
      "sector_efada": "",
      "pmo_efada": "إرفاق : - ميثاق المشروع -الجدول الزمني ",
      "cat_efada": "",
      "YearBudget": "",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "a52bef22-1275-eb11-8af1-005056921d78",
      "ProjectName": "تطوير محرك Chatbot",
      "Department": "إدارة تقنية المعلومات",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "محمد عبدالله السند Mohammed A. Alsanad",
      "ProjectDescription": "تشغيل وتفعيل نظام إدارة تخطيط الموارد المؤسسي",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "نظام إدارة تخطيط الموارد المؤسسي (ERP)",
      "EstimatedBudget": 8000000,
      "ApprovedBudget": 8000000,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "الأنظمة والتطوير",
      "AwardedCompany": "",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "استلام العروض",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2024-10-31T00:00:00",
      "BudgetCategory": "الرأس مالية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": "نوره محمد أبونيان Noura M. Abunayyan",
      "ProjectOwner1": "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
      "ProjectOfficerContact": " ",
      "sector_efada": "انتهت فترة استلام العروض و حالياً في مرحلة التحليل الفني ",
      "pmo_efada": "",
      "cat_efada": "الأنظمة و التطوير",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "638f41d8-1975-eb11-8af1-005056921d78",
      "ProjectName": "اطار إدارة المخاطر",
      "Department": "إدارة التمكين والتنمية",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "سيف عبدالله ابراهيم الفرهود SAIF A. ALFARHOOD",
      "ProjectDescription": "تصميم نموذج يعزز الاستقلال المالي المشاريع منتاهية الصغر من خلال تأهيل علامتها التجارية وتطويرها واعتمادها وتقديم الدعم التشغيلي و التسويقي ومتابعة أدائها وتقويم أعمالها",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 9270210,
      "ApprovedBudget": 9270210,
      "ContractValue": 0,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": null,
      "AwardedCompany": "",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "اصدار التوصية",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2024-05-18T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "سعد حمد سعد بن عيد SAAD H. BINEID",
      "ProjectOwner1": "ناصر رخيص العنزي Nasser R Alanzi",
      "ProjectOfficerContact": "سيف عبدالله ابراهيم الفرهود SAIF A. ALFARHOOD",
      "sector_efada": "جاري مفاوضة الشركات على تخفيض عرضها المالي",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "46f1405a-1d75-eb11-8af1-005056921d78",
      "ProjectName": "اقفال المشاريع المكتملة و الغير مغلقة",
      "Department": "إدارة الإئتمان",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "محمد الحميدي الحربي Mohammed A Alharbi",
      "ProjectDescription": "هو نظام يساعد متخذ القرار لاتخاذ قرار ائتماني في ما يخص طلبات التمويل للمنشآت بناء على تصنيف درجة مخاطر العملاء بناء على تقييم جوانب تشمل القدرات الإدارة والقدرات المالية...الخ",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "3112",
      "BudgetItemName": "تقنية المعلومات",
      "EstimatedBudget": 3000000,
      "ApprovedBudget": 3000000,
      "ContractValue": 3000000,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "الداخلي",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-11-15T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Ahmed S. Aldubais",
      "ProjectOwner1": "عبدالمجيد صالح الكريديس Abdulmajed S. AlKriedees",
      "ProjectOfficerContact": "محمد الحميدي الحربي Mohammed A Alharbi",
      "sector_efada": "تم تنفيذ المشروع داخلياُ وعليه تم الغاء طرح المشروع خارجياً حسب افادة الإدارة المالكة ",
      "pmo_efada": "تم تحويل المشروع الى داخلي حسب افادة القطاع وتم ارسال BRD وهو في مرحلة التنفيذ ",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "7790b2de-1e75-eb11-8af1-005056921d78",
      "ProjectName": "مشروع الدعم المحاسبي",
      "Department": "إدارة المحافظ والتطوير",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "عزت فيصل العنقري Ezzat F AlAngari",
      "ProjectDescription": "نظام يساعد على الاطلاع على الحدود ومعرفة المتاح والمصروف",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "",
      "EstimatedBudget": 4000000,
      "ApprovedBudget": 4000000,
      "ContractValue": 4000000,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "",
      "ProjectPhase": "البدء",
      "ProjectStatus": "متأخر",
      "ContractStatus": "إعداد الطرح",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-11-15T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": " ",
      "ProjectOwner1": "فهد علي الاشقر Fahad A. Alashgar",
      "ProjectOfficerContact": "عزت فيصل العنقري Ezzat F AlAngari",
      "sector_efada": "",
      "pmo_efada": "لا يوجد تحديث على المشروع",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "a2bf0174-2375-eb11-8af1-005056921d78",
      "ProjectName": "نظام الاصول الثابته",
      "Department": "إدارة تمويل الأسر المنتجة",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "هدى عثمان احمد الزهراني huda o. alzahrani",
      "ProjectDescription": "تقييم الجهات الشريكة ذاتيا من خلال منصة الكترونية",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "",
      "BudgetItemName": "الاسر المنتجة",
      "EstimatedBudget": 1700000,
      "ApprovedBudget": 1700000,
      "ContractValue": 1187743,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Tier (1)",
      "ProjectCategory": null,
      "AwardedCompany": "الشركة الوطنية لخدمة البيانات والحلول المتكاملة",
      "ProjectPhase": "التخطيط",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-11-25T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
      "ProjectOfficerContact": " ",
      "sector_efada": "تم توقيع العقد و البدء في اجراءات التخطيط للمشروع",
      "pmo_efada": "",
      "cat_efada": "",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "b80b1dc8-2475-eb11-8af1-005056921d78",
      "ProjectName": "مشروع تطوير البرامج والتوجهات الاستراتيجية",
      "Department": "إدارة التسويق والعلاقات العامة",
      "ProjectOwner": "معيض ناصر البيشي Meaid N Albishi",
      "ProjectManager": "حنان عبدالرحمن الدليمي Hanan A. Al Delaimi",
      "ProjectDescription": "يهدف هذا المشروع لتطوير الاستراتيجية الرقمية لبنك التنمية الاجتماعية وإدارة القنوات الرقمية بما يخدم التوجهات الإعلامية والتسويقية لمنتجات وخدمات ومبادرات البنك ويشمل ذلك المحتوى والنشر والتقارير.",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2022-03-24T17:00:00",
      "BIProjectStartDate": "2021-03-25T08:00:00",
      "BIProjectFinishDate": "2022-03-24T17:00:00",
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "238",
      "BudgetItemName": "نفقات التسويق والمواد الإعلامية",
      "EstimatedBudget": 2199605,
      "ApprovedBudget": 2199605,
      "ContractValue": 2199605,
      "RevisedContractValue": 0,
      "PaidAmount": "1,536,400.00",
      "RemainingAmount": 663205,
      "ProjectType": "خارجي",
      "Priority": "Tier (2)",
      "ProjectCategory": "اختر",
      "AwardedCompany": "التقييم الفني",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الاستراتيجية",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2022-11-16T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "تعزيز التواصل و تحسين الصورة الذهنية ",
      "PortfoilioName": "قطاع الاستراتيجية والابتكار",
      "ProgramManager": "خالد راشد الثويني Khaled R Althowaini",
      "ProjectOwner1": "بندر سعيد الغامدي Bandar S. Alghamdi",
      "ProjectOfficerContact": " ",
      "sector_efada": "",
      "pmo_efada": "رفع الجدول الزمني للمشاريع على النظام مع خطة الدفعات ",
      "cat_efada": "",
      "YearBudget": "663,205.00",
      "SpentYearBudget": null
    },
    {
      "ProjectUID": "68e05623-2a75-eb11-8af1-005056921d78",
      "ProjectName": "تطوير لوحة المؤشرات الخاصة بالعقود Dashboard",
      "Department": "إدارة الخدمات المساندة",
      "ProjectOwner": "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
      "ProjectManager": "عبدالله سليمان عبدالله الحمود ABDULLAH S. ALHAMOD",
      "ProjectDescription": null,
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T08:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "3112",
      "BudgetItemName": "تقنية المعلومات ",
      "EstimatedBudget": 3500000,
      "ApprovedBudget": 3500000,
      "ContractValue": 3500000,
      "RevisedContractValue": 895.9,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "الأنظمة والتطوير",
      "AwardedCompany": "شركة أعمال الحلول المترابطة",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "حسب المخطط",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع الخدمات المشتركة",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2024-03-01T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الخدمات المشتركة",
      "ProgramManager": "Rawan M. Alsoghayer",
      "ProjectOwner1": "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
      "ProjectOfficerContact": " ",
      "sector_efada": "جاري التنفيذ حسب الخطه والجدول الزمني ",
      "pmo_efada": "الإفادة السابقة بأطلاق المشروع في ديسمبر 2021 ، يوجد تغيير الى 2024 ",
      "cat_efada": "الأنظمة و التطوير",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
    {
      "ProjectUID": "8af99b70-2b75-eb11-8af1-005056921d78",
      "ProjectName": "برنامج تطوير وأتمتة الإجراءات بحسب ISO 20000",
      "Department": "إدارة تمويل الأفراد",
      "ProjectOwner": "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
      "ProjectManager": "محمد سعود البليهد Mohammed S. Alblaihed",
      "ProjectDescription": "تامين الحياة على كامل محفظة القروض الاجتماعية والعمل الحر ضد حالات الوفاة والعجز الكلي",
      "ProjectStartDate": "2021-02-22T08:00:00",
      "ProjectFinishDate": "2021-02-22T17:00:00",
      "BIProjectStartDate": null,
      "BIProjectFinishDate": null,
      "PlannedCompletePercent": 0,
      "ActualCompletePercent": 0,
      "BudgetItemNo": "241",
      "BudgetItemName": "التامين على القروض الاجتماعية",
      "EstimatedBudget": 154000000,
      "ApprovedBudget": 154000000,
      "ContractValue": 154000000,
      "RevisedContractValue": 0,
      "PaidAmount": "0.00",
      "RemainingAmount": 0,
      "ProjectType": "خارجي",
      "Priority": "Special Tier (1)",
      "ProjectCategory": "الأنظمة والتطوير",
      "AwardedCompany": "",
      "ProjectPhase": "التنفيذ",
      "ProjectStatus": "تم الاطلاق(مكتمل)",
      "ContractStatus": "العقد",
      "ProjectSector": "قطاع التطوير",
      "Program": null,
      "تاريخ نهاية المشروع المتوقع": "2021-10-30T00:00:00",
      "BudgetCategory": "تشغيلية",
      "BankProjectTypes": "تشغيلي",
      "PlannedResourceHours": 0,
      "ActualResourceHours": 0,
      "StrategicObjectives": "",
      "PortfoilioName": "قطاع الاعمال",
      "ProgramManager": "Khalid S. Alsoke",
      "ProjectOwner1": "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
      "ProjectOfficerContact": "وليد سليمان النزهه Waleed S. Alnozha",
      "sector_efada": "",
      "pmo_efada": "",
      "cat_efada": "الأنظمة و التطوير",
      "YearBudget": "0.00",
      "SpentYearBudget": 0
    },
  ]